import { TeamInfoWithAdmin } from '@common/queries/team';
import { theme } from '@prophecy/theme';
import { Button } from '@prophecy/ui-v3/Button';
import { Stack, StackItem } from '@prophecy/ui-v3/Layout';
import { Text } from '@prophecy/ui-v3/Typography';
import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

import { useExecutionMetricsForm } from '../hooks/useFormContext';
import useUpdateExecutionMetrics from '../hooks/useUpdateExecutionMetrics';
import ExecutionMetricsDescription from './ExecutionMetricsDescription';
import ExecutionMetricsForm from './ExecutionMetricsForm';

const ExecutionMetricsContainer = styled.div`
  height: 100%;
  padding: 0 ${theme.spaces.x24};
`;

export const ExecutionMetricsTab = ({ teamId, data }: { teamId: string; data?: TeamInfoWithAdmin }) => {
  const formContext = useExecutionMetricsForm();
  const [hasErrors, setHasErrors] = useState(false);
  const { updateExecutionMetrics, isLoading } = useUpdateExecutionMetrics(formContext);

  useEffect(() => {
    if (data) {
      const executionMetrics = JSON.parse(data?.adminInfo?.[0]?.AspectValue || '{}').executionMetrics || {
        enabled: false
      };

      if (executionMetrics) {
        formContext.reset(executionMetrics);
      }
    }
  }, [formContext, data]);

  const onSubmit = useCallback(() => {
    updateExecutionMetrics(teamId);
  }, [updateExecutionMetrics, teamId]);

  return (
    <>
      <ExecutionMetricsContainer>
        <Stack gap={theme.spaces.x16} height='100%'>
          <Text level='lg' weight={theme.fontWeight.medium} tone={theme.colors.gray900}>
            Execution Metrics
            <ExecutionMetricsDescription />
          </Text>

          <ExecutionMetricsForm formContext={formContext} updateTeamErrors={setHasErrors} />

          <StackItem grow='1' />

          <Stack direction='horizontal' align='end' gap={theme.spaces.x12}>
            <Button
              variant='primary'
              size='m'
              loading={isLoading}
              disabled={hasErrors || isLoading}
              onClick={onSubmit}
              data-test-id='execution-metrics-tab-update-button'>
              Update
            </Button>
          </Stack>
        </Stack>
      </ExecutionMetricsContainer>
    </>
  );
};
